<!-- Admin: link this Sales Assistant to the agent(s) they can act as. Parent decides when to render this. -->
<div class="frame-box assign-agents">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <p class="_fw-600 f-14 mb-0">Sales Assistant Assign Agents</p>
  </div>

  <p class="assign-agents-desc f-12">
    Choose which agents this user can work on behalf of. They log in as themselves, then
    <b>act as</b> a selected agent from the top bar.
  </p>

  <div class="form-group">
    <label class="mb-1" for="assignAgents">Agents</label>
    <ng-select
      id="assignAgents"
      [items]="agentOptions"
      bindLabel="full_name"
      bindValue="_id"
      [multiple]="true"
      [closeOnSelect]="false"
      [loading]="loading"
      [(ngModel)]="selectedAgentIds"
      placeholder="Select agents">
    </ng-select>
  </div>

  <div class="d-flex align-items-center gap-2 mt-3">
    <button type="button" class="_primary-btn" [disabled]="saving" (click)="save()">
      {{ saving ? 'Saving…' : 'Save assigned agents' }}
    </button>
    <button type="button" class="btn btn-link btn-sm text-danger p-0 ml-2" [disabled]="saving" (click)="clearAll()">
      Remove all
    </button>
  </div>
</div>
